import { useState } from 'react';
import { makeStyles } from '@ellucian/react-design-system/core';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { fontSizeSmall, spacing40 } from '@ellucian/react-design-system/core/styles/tokens';
import { routes } from '../Helpers/Configuration';
import { getMfaReturnUrl } from '../Helpers/fileHelpers';
import { useApi } from '../ApiContext';
import { useSnackbar } from '../SnackbarContext/SnackbarContext';
import { Button, Typography } from '@ellucian/react-design-system/core';
import { FormattedMessage } from 'react-intl';
import LoadingButton from '../Common/LoadingButton';


const useStyles = makeStyles({
    name: 'LostRecoveryCode'
})((theme) => ({
    root: {
        padding: `${spacing40} 0`,
        width: '100%',
    },
    container: {
        margin: '4rem auto 4rem auto',
        maxWidth: '800px',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.down('md')]: {
            margin: '0',
        },
    },
    mainGrid: {
        alignItems: 'center',
        width: '70%',
        [theme.breakpoints.down('md')]: {
            width: '90%',
        },
    },
    wrapper: {
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        textAlign: 'justify',
        marginBottom: spacing40
    },
    buttonContainer: {
        display: 'flex',
        flexDirection: 'row-reverse',
        marginTop: spacing40
    },
    button: {
        marginLeft: spacing40
    },
    codeContainer: {
        [theme.breakpoints.down('md')]: {
            width: '100%',
        },
    },
    title: {
        [theme.breakpoints.down('md')]: {
            fontSize: fontSizeSmall,
        },
    },
}));
const LostRecoveryCode = () => {
    const intl = useIntl();
    const { classes } = useStyles();
    const history = useHistory();
    const api = useApi();
    const snackbar = useSnackbar();
    const [isDisabled, setIsDisabled] = useState(false);
    const userEmail = window.PRELOADED_STATE?.user?.email || '';
    const model = {
        email: userEmail,
    };
    const handleSubmit = async () => {
        try {
            setIsDisabled(true);
            const result = await api.mfaAuth.mfaReset();
            const { mfaEnabled = false } = result;
            if (!mfaEnabled) {
                window.location.href = getMfaReturnUrl() || routes.home;
                return;
            }
            await api.inquiries.retrieve(model);
            history.replace(routes.totpResetConfirm);
        } catch (_e) {
            snackbar.error(intl.formatMessage({ id: 'mfaResetError' }));
            setIsDisabled(false);
        }
    };
    const handleBack = (e) => {
        e.preventDefault();
        history.replace(routes.totpReset);
    };

    return (
        <div className={classes.root}>
            <div className={classes.container}>
                <div  className={classes.mainGrid}>
                    <div className={classes.wrapper}>
                        <Typography>
                            <FormattedMessage id="applicationRetrievalLostRecoveryCodeInstructions" />
                        </Typography>
                    </div>
                    <div className={classes.buttonContainer}>
                        <LoadingButton
                            isLoading={isDisabled}
                            color="primary"
                            className={classes.button}
                            onClick={handleSubmit}
                            aria-label={intl.formatMessage({ id: 'confirm' })}
                        >
                            <FormattedMessage id="confirm" />
                        </LoadingButton>
                        <Button color="secondary" className={classes.button} onClick={(e)=>handleBack(e)} disabled={isDisabled} aria-label={intl.formatMessage({ id: 'back' })}>
                            <FormattedMessage id="back" />
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default LostRecoveryCode;